import {useMemo} from 'react';
import useSearchParam from 'src/hooks/useSearchParam';

const typeFilters: {[filterType: string]: string[]} = {
  cities: ['city', 'town', 'village'],
  nature: ['natureReserve', 'nationalPark', 'peak'],
  islands: ['island']
};

export const filterPlaces = (places: Place[], typeFilter: string, countryFilter: string) => {
  const allDefinedTypes = [...typeFilters.cities, ...typeFilters.nature, ...typeFilters.islands];

  return places.filter((place) => {
    if (typeFilter) {
      if (typeFilter === 'other' && allDefinedTypes.includes(place.placeType)) return false;

      if (typeFilter && typeFilters[typeFilter] && !typeFilters[typeFilter]?.includes(place.placeType)) return false;
    }

    if (countryFilter && place.countryCode !== countryFilter) return false;

    return true;
  });
};

export const useFilteredPlaces = (places: Place[]) => {
  const [typeFilter] = useSearchParam('placeType');
  const [countryFilter] = useSearchParam('country');

  const filteredEntries: Place[] = useMemo(
    () => filterPlaces(places, typeFilter, countryFilter),
    [typeFilter, countryFilter, places]
  );

  return filteredEntries;
};
